import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-301">
      <div className="max-w-3xl mx-auto text-center" data-id="element-302">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-303">
          Si sos entrenador o profesor de básquet,
          <br data-id="element-304" />
          <span className="text-[#F97316]" data-id="element-305">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-306">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-307">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-308">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-309">
              Llegás a la cancha sin saber exactamente qué ejercicio vas a dar
              hoy
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-310">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-311">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-312">
              Tus jugadores más jóvenes no progresan porque no tenés una
              secuencia clara por categoría
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-313">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-314">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-315">
              El 60% de los jugadores abandona antes del año y no sabés cómo
              prevenirlo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-316">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-317">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-318">
              Cuando falta el gimnasio o hay pocos jugadores improvisás porque
              no tenés un Plan B listo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-319">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-320">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-321">
              No podés demostrar tu trabajo porque no tenés un sistema
              profesional visible frente al club y los padres
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-322">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-323">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-324">
              Siempre las mismas correcciones improvisadas sin un método claro
              que te respalde
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-325">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-326">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-327">
              Tenés jugadores de distintos niveles y categorías juntos y el
              entrenamiento se convierte en caos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-328">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-329">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-330">
              Los padres preguntan si su hijo mejora y no tenés datos concretos
              para responderles
            </p>
          </div>
        </div>

        <p className="text-[#F97316] text-2xl sm:text-3xl font-black mb-8" data-id="element-331">
          ¿Cuántos entrenamientos más vas a improvisar?
        </p>

        {/* Orange divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#F97316] to-transparent w-full" data-id="element-332" />
      </div>
    </section>;
}